<template>
  <div>
    <list
      row-key="RecordId"
      ref="list"
      unit="操作日志"
      :page="page"
      :show-checkbox="false"
      :show-query="true"
      :query-params="params"
      :get-data-func="api.list"
      v-if="trendShow"
      urlHash="facility/equipment/oplogdata"
      :temp-params="tempParams"
    >
      <template slot="toolbar-right">
        <el-button type="primary" plain @click="onExport">导出 Excel</el-button>
        <el-button type="primary" plain @click="onRefresh">刷新</el-button>
      </template>
    </list>
  </div>
</template>

<script>
import listMixin from '@/mixins/trend/list'
import list from '@/components/common/trendsTable/list'

export default {
  name: 'OplogList',
  mixins: [listMixin],
  components: { list },
  props: {
    page: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      api: require('@/api/equipment/lgoplog').default,
      trendShow: true,
      params: {
        EquipmentId: null
      },
      tempParams: {}
    }
  },
  methods: {
    // 初始化（由父组件调用，传入设备ID）
    getDatas(id) {
      this.params.EquipmentId = id
      this.$refs.list.query(this.params)
    },
    // 导出
    onExport() {
      const loading = this.$loading({
        lock: true,
        text: '正在导出...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.3)'
      })
      // 获取完整的查询参数（包含 EquipmentId 和时间筛选）
      const queryParams = this.$refs.list.queryParams
      this.api.export(queryParams).then(res => {
        loading.close()
        // 创建下载链接
        const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = '操作日志.xlsx'
        link.click()
        window.URL.revokeObjectURL(url)
      }).catch(() => {
        loading.close()
        this.$message.error('导出失败')
      })
    },
    // 刷新
    onRefresh() {
      this.reload()
    }
  }
}
</script>
